import { styled, Stack, Typography } from '@mui/material';

export const Container = styled(Stack)({
  flexDirection: 'row',
  gap: 8,
  alignItems: 'center',
});

export const Num = styled(Typography)(({ theme }) => ({
  ...theme.typography.textXsMedium,
  color: theme.palette.primary[600],
  width: 20,
  height: 20,
  border: `2px solid ${theme.palette.primary[600]}`,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
}));

export const Label = styled(Typography)(({ theme }) => ({
  ...theme.typography.textSmMedium,
}));
